import React, {useState} from 'react';
import ReactPlayer from 'react-player';
import Module from '../Module/Module';
import './CourseStructure.css';

const CourseStructure = (props) => {
  console.log(props.isLoggedIn);
  let [isPlayingVideo, setIsPlayingVideo] = useState(true);
  let [isCourseBought, setIsCourseBought] = useState(localStorage.getItem('is_bought'));
  let lect1 = [
    {
            "id": 1,
            "video_key": "Lecture 1: Introduction",
            "video_url": "https://d3f38orhyn0llf.cloudfront.net/18707cb6-daf9-476a-9d47-187eaabc4f88/mp4/1.INTRODUCTION _Mp4_Avc_Aac_16x9_1280x720p_24Hz_4.5Mbps_qvbr.mp4",
                  "total_time_duration": "05:11",
                        "user_video_course_statuses": []
          },
        {
                "id": 2,
                "video_key": "Lecture 2: Accounting Principles",
                      "video_url": "https://d3f38orhyn0llf.cloudfront.net/05a9f81d-f84b-49fe-b959-c2a97aceca6e/mp4/2.ACCOUNTING PRINCIPLES AND BASICS_Mp4_Avc_Aac_16x9_1280x720p_24Hz_4.5Mbps_qvbr.mp4",
                            "total_time_duration": "10:01",
                                  "user_video_course_statuses": []
              }
  ];
  let total_time_lect1 = "15:12";
  let num_lectures_lect1 = "2";
  let lect2 = [
        {
                "id": 3,
                "video_key": "Lecture 3: Components of Financial Statements",
                "video_url": "https://d3f38orhyn0llf.cloudfront.net/16d85d2a-815a-4542-94f1-218a2abaa17a/mp4/COMPONENTS OF FS_Mp4_Avc_Aac_16x9_1280x720p_24Hz_4.5Mbps_qvbr.mp4",
                      "total_time_duration": "06:41",
                            "user_video_course_statuses": []
              },
        {
                "id": 4,
                "video_key": "Lecture 4(Intro): Financial Statements based on the nature of the business",
                "video_url": "https://d3f38orhyn0llf.cloudfront.net/27fef7af-d08e-4b75-9c32-2148f99a72d9/mp4/4. FS BASED ON NATURE OF BUSINESSES_Mp4_Avc_Aac_16x9_1280x720p_24Hz_4.5Mbps_qvbr.mp4",
                "total_time_duration": "11:16",
                "user_video_course_statuses": []
              },
        {
                "id": 5,
                "video_key": "Lecture 4(A) Profit and loss statement",
                "video_url": "https://d3f38orhyn0llf.cloudfront.net/10b72871-1c48-49a6-a995-ad070bc5f972/mp4/A PL_Mp4_Avc_Aac_16x9_1280x720p_24Hz_4.5Mbps_qvbr.mp4",
                "total_time_duration": "08:45",
                "user_video_course_statuses": []
              },
        {
                "id": 6,
                "video_key": "Lecture 4(B) Balance Sheet and cash flows",
                "video_url": "https://d3f38orhyn0llf.cloudfront.net/a411dcfc-57f9-4de2-ad3d-d61b37465b46/mp4/B BS CF_Mp4_Avc_Aac_16x9_1280x720p_24Hz_4.5Mbps_qvbr.mp4",
                "total_time_duration": "09:16",
                "user_video_course_statuses": []
              },
        {
                "id": 7,
                "video_key": "Lecture 4(C) Notes to accounts",
                "video_url": "https://d3f38orhyn0llf.cloudfront.net/27669a7c-ba40-4c58-a32e-a1e63f4b6bcc/mp4/C NOTES_Mp4_Avc_Aac_16x9_1280x720p_24Hz_4.5Mbps_qvbr.mp4",
                "total_time_duration": "13:16",
                "user_video_course_statuses": []
              },
        {
                "id": 8,
                "video_key": "Lecture 6: Supplementary statements attached to Financial Statements",
                "video_url": "https://d3f38orhyn0llf.cloudfront.net/72402a83-5db7-4576-bc11-d5e4f31476ae/mp4/6. Supplementary reports attached to Financial Statements - Audit Report, Directors' Report_Mp4_Avc_Aac_16x9_1280x720p_24Hz_4.5Mbps_qvbr.mp4",
                "total_time_duration": "06:54",
                "user_video_course_statuses": []
              }
  ];
  let total_time_lect2 = "55:00";
  let num_lectures_lect2 = "6";
  let lect3 = [
    {
            "id": 9,
            "video_key": "Lecture 7 (A): Comparative Statements",
            "video_url": "https://d3f38orhyn0llf.cloudfront.net/d0d34909-e8dc-4639-9f38-12198620f20b/mp4/7a. Tools to Analyze Financial Statements - Comparative Statements_Mp4_Avc_Aac_16x9_1280x720p_24Hz_4.5Mbps_qvbr.mp4",
            "total_time_duration": "04:29",
            "user_video_course_statuses": []
          },
        {
                "id": 10,
                "video_key": "Lecture 7 (B): Common-size Statements",
                "video_url": "https://d3f38orhyn0llf.cloudfront.net/a1a9eb23-7706-446c-8cb8-8b91068b13cb/mp4/7b. Common Size Statements_Mp4_Avc_Aac_16x9_1280x720p_24Hz_4.5Mbps_qvbr.mp4",
                "total_time_duration": "03:10",
                "user_video_course_statuses": []
              },
        {
                "id": 11,
                "video_key": "Lecture 7 (C): Trend Analysis",
                "video_url": "https://d3f38orhyn0llf.cloudfront.net/e890bb23-8331-4ed1-88b9-715c67f0f220/mp4/7c. Trend Analysis_Mp4_Avc_Aac_16x9_1280x720p_24Hz_4.5Mbps_qvbr.mp4",
                "total_time_duration": "10:29",
                "user_video_course_statuses": []
              },
        {
                "id": 12,
                "video_key": "Lecture 8 (A): Profitability Ratios",
                "video_url": "https://d3f38orhyn0llf.cloudfront.net/b442598f-fa80-41ad-8b97-45387a2ee555/mp4/8A_Mp4_Avc_Aac_16x9_1280x720p_24Hz_4.5Mbps_qvbr.mp4",
                "total_time_duration": "32:37",
                "user_video_course_statuses": []
              },
        {
                "id": 13,
                "video_key": "Lecture 8 (B): Efficiency Ratios",
                "video_url": "https://d3f38orhyn0llf.cloudfront.net/df226562-c33f-4c4e-97f2-64fad2284c57/mp4/8B _Mp4_Avc_Aac_16x9_1280x720p_24Hz_4.5Mbps_qvbr.mp4",
                "total_time_duration": "25:59",
                "user_video_course_statuses": []
              },
        {
                "id": 14,
                "video_key": "Lecture 8 (C): Liquidity Ratios",
                "video_url": "https://d3f38orhyn0llf.cloudfront.net/a6343262-7692-435b-95a1-52fa09518995/mp4/8C_Mp4_Avc_Aac_16x9_1280x720p_24Hz_4.5Mbps_qvbr.mp4",
                "total_time_duration": "19:58",
                "user_video_course_statuses": []
              },
        {
                "id": 15,
                "video_key": "Lecture 8 (D): Solvency Ratios",
                "video_url": "https://d3f38orhyn0llf.cloudfront.net/8b76b3b0-7542-48d2-8d34-d2749f274c24/mp4/8D_Mp4_Avc_Aac_16x9_1280x720p_24Hz_4.5Mbps_qvbr.mp4",
                "total_time_duration": "14:58",
                "user_video_course_statuses": []
              }
  ];
  let total_time_lect3 = "1:45:00";
  let num_lectures_lect3 = "7";
  let lect4 = [
     {
             "id": 16,
             "video_key": "Lecture 9: Dupont Analysis, FCFF and FCFE",
             "video_url": "https://d3f38orhyn0llf.cloudfront.net/2e25d62b-106e-41c3-a0fd-5782189929a9/mp4/dupont FCFF FCFE_Mp4_Avc_Aac_16x9_1280x720p_24Hz_4.5Mbps_qvbr.mp4",
             "total_time_duration": "10:54",
             "user_video_course_statuses": []
           },
        {
                "id": 17,
                "video_key": "Lecture 10: Deferred Tax",
                "video_url": "https://d3f38orhyn0llf.cloudfront.net/4a3fe3b6-0778-48ed-97e8-e13e0ca5d07b/mp4/deferred tax assetliability_Mp4_Avc_Aac_16x9_1280x720p_24Hz_4.5Mbps_qvbr.mp4",
                "total_time_duration": "07:01",
                "user_video_course_statuses": []
              }
  ];
  let total_time_lect4 = "17:55";
  let num_lectures_lect4 = "2";
  return (
    <div class='course-structure-container'>
      {isPlayingVideo && 
        <div class='course-structure-video'>
          <ReactPlayer url='https://media.w3.org/2010/05/sintel/trailer_hd.mp4' controls='true'/>
        </div>
      }
      <span class='course-structure-header-container'>
        <span class='course-structure-header'>
          Course Structure
        </span>
      </span>
      <span class='course-structure-header-module-gutter'/>
      <span class='course-structure-modules-container'>
        <Module name={"Module 1 - Introduction and Basics"} lectures={lect1} isLoggedIn={props.isLoggedIn} total_time={total_time_lect1} num_lectures={num_lectures_lect1} is_bought={isCourseBought}/>
        <Module name={'Module 2 - Components of a Financial Statement'} lectures={lect2} isLoggedIn={props.isLoggedIn} total_time={total_time_lect2} num_lectures={num_lectures_lect2} is_bought={isCourseBought}/>
        <Module name={'Module 3 – Tools to Analyse Financial Statements'} lectures={lect3} isLoggedIn={props.isLoggedIn} total_time={total_time_lect3} num_lectures={num_lectures_lect3} is_bought={isCourseBought}/>
        <Module name={'Module 4 – Introduction to Advance Level Analysis And Misc'} lectures={lect4} isLoggedIn={props.isLoggedIn} total_time={total_time_lect4} num_lectures={num_lectures_lect4} is_bought={isCourseBought}/>
      </span>
    </div>
  )
}
export default CourseStructure;
